import { Tooltip } from '@cian/ui-kit';
import * as React from 'react';
import { IAreaPartExpandToggleProps } from './types';
import { AreaPartExpandButton } from '../../../../buttons/AreaPartExpandButton/AreaPartExpandButton';

export const AreaPartExpandToggle: React.FC<IAreaPartExpandToggleProps> = props => {
  const { expanded, isTooltipOpened, onClick } = props;

  const button = (
    <div>
      <AreaPartExpandButton expanded={expanded} onClick={onClick} active={!isTooltipOpened} />
    </div>
  );

  if (isTooltipOpened) {
    return (
      <Tooltip placement="bottom" title="Добавьте параметры площади, чтобы свернуть её" header="Свернуть площадь">
        {button}
      </Tooltip>
    );
  }

  return button;
};
